export const TIERING_API = {
  TIERS: "/engagement/loyalty-tiers",
  MERCHANT_TIER_INFO: "/engagement/merchant-loyalty-tier",
};
